import React from 'react';
import { Container, Typography, Box, Paper, Divider, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import EmailIcon from '@mui/icons-material/Email';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const Support = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default', py: 4 }}>
      <Container maxWidth="md">
        <Box sx={{ mb: 3 }}>
          <IconButton onClick={() => navigate('/')} sx={{ color: 'text.primary' }}>
            <ArrowBackIcon />
          </IconButton>
        </Box>

        <Paper elevation={3} sx={{ p: 4, backgroundColor: 'background.paper' }}>
          <Typography variant="h3" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
            Support
          </Typography>

          <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 4 }}>
            We're here to help you get the most out of Prelude.
          </Typography>

          <Divider sx={{ mb: 3 }} />

          {/* Contact */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <EmailIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              Contact Us
            </Typography>
          </Box>
          <Typography variant="body1" paragraph>
            For any questions, issues, or feedback, please reach out to us at:
          </Typography>
          <Typography variant="body1" paragraph sx={{ ml: 2 }}>
            <Link href="mailto:support@joinprelude.co" underline="hover" color="primary">
              support@joinprelude.co
            </Link>
          </Typography>
          <Typography variant="body1" paragraph>
            We typically respond within 24 hours.
          </Typography>

          <Divider sx={{ my: 3 }} />

          {/* FAQ */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <HelpOutlineIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              Frequently Asked Questions
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
            What is Prelude?
          </Typography>
          <Typography variant="body1" paragraph>
            Prelude is a worship service planning platform that helps churches organize their services, manage worship teams, and keep track of songs and schedules.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
            How do I join my church on Prelude?
          </Typography>
          <Typography variant="body1" paragraph>
            Ask your church admin for the Church Confirmation Code. When you register, select "Member" or "Leader" and enter the code to join your church.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
            How do I create a church?
          </Typography>
          <Typography variant="body1" paragraph>
            Register as an "Admin" and enter your church name. A confirmation code will be generated automatically for your team members to join.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
            Can I use Prelude on my phone?
          </Typography>
          <Typography variant="body1" paragraph>
            Yes! Prelude is available on the Apple App Store for iOS devices. You can also access the web version from any browser.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
            How do I delete my account?
          </Typography>
          <Typography variant="body1" paragraph>
            You can delete your account from the Settings screen in the mobile app. Go to Settings, scroll to the bottom, and tap "Delete Account". This action is permanent and will remove all your data. You can also request account deletion by emailing{' '}
            <Link href="mailto:support@joinprelude.co" underline="hover" color="primary">
              support@joinprelude.co
            </Link>.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
            What languages does Prelude support?
          </Typography>
          <Typography variant="body1" paragraph>
            Prelude currently supports English, Portuguese, and Spanish. You can change the language in the Settings screen.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
            How do I reset my password?
          </Typography>
          <Typography variant="body1" paragraph>
            Please contact us at{' '}
            <Link href="mailto:support@joinprelude.co" underline="hover" color="primary">
              support@joinprelude.co
            </Link>{' '}
            and we will help you reset your password.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="body2" color="text.secondary" align="center">
            Prelude - Worship Service Planning Platform
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            <Link href="/privacy" underline="hover" color="inherit">
              Privacy Policy
            </Link>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Support;
